import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { useQuestionLibraryStore } from '../store/questionLibraryStore';
import type { ElementConditions } from '../types/common';
import { evaluateCondition } from './utils';

export const useConditionsEvaluator = (
  conditions: ElementConditions = {},
  metadata: Record<string, unknown> = {},
) => {
  const screenData = useQuestionLibraryStore((s) => s.screenData);
  const { watch } = useFormContext();
  const allFields = watch();

  const defaultConditions = {
    isVisible: true,
    isDisabled: false,
    isRequired: true,
    isExpanded: false,
  };

  return useMemo(() => {
    const evaluatedConditions = Object.entries(conditions).reduce(
      (acc, [key, condition]) => {
        acc[key] = condition
          ? evaluateCondition(condition, allFields, screenData, metadata)
          : defaultConditions[key];
        return acc;
      },
      { ...defaultConditions },
    );
    return evaluatedConditions;
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [screenData, allFields]);
};
